import { quoteStatusFragment } from '#fragments/quote_status.js';
import { gql } from '@apollo/client/core';

export const QUOTE_STATUS_QUERY_LIST = gql`
  ${quoteStatusFragment}
  query QuoteStatusQueryList($limit: Int, $offset: Int, $orderBy: [quote_status_order_by!], $where: quote_status_bool_exp) {
    quote_status(
      limit: $limit,
      offset: $offset,
      order_by: $orderBy,
      where: $where
    ) {
      ...QuoteStatusFragment
    }
  }
`;

export const QUOTE_STATUS_QUERY = gql`
  ${quoteStatusFragment}
  query QuoteStatusQuery($id: Int!) {
    quote_status_by_pk(id: $id) {
      ...QuoteStatusFragment
    }
  }
`;

export const QUOTE_STATUS_INSERT = gql`
  ${quoteStatusFragment}
  mutation InsertQuoteStatus($object: quote_status_insert_input!) {
    insert_quote_status_one(object: $object) {
      ...QuoteStatusFragment
    }
  }
`;

export const QUOTE_STATUS_UPDATE = gql`
  ${quoteStatusFragment}
  mutation UpdateQuoteStatus($id: bigint!, $object: quote_status_set_input!) {
    update_quote_status_by_pk(pk_columns: { id: $id }, _set: $object) {
      ...QuoteStatusFragment
    }
  }
`;

export const QUOTE_STATUS_DELETE = gql`
  mutation DeleteQuoteStatus($id: bigint!) {
    delete_quote_status_by_pk(id: $id) {
      id
    }
  }
`;

export const QUOTE_STATUS_BULK_UPDATE = gql`
  mutation QuoteStatusBulkUpdate($updates: [quote_status_updates!]!) {
    update_quote_status_many(updates: $updates) {
      affected_rows
    }
  }
`;
